import { Link } from 'react-router-dom';

const CatalogSection = () => {
  const catalogs = [
    {
      id: 1,
      title: 'Tecnutri Food Service',
      description: 'Conheça toda nossa linha de produtos alimentícios',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/7ed114f78e12a0a969de59f6a444c329.jpeg',
      downloadUrl: 'https://www.tecnutrifoodservice.com.br/'
    },
    {
      id: 2,
      title: 'Enjoy',
      description: 'Conheça toda nossa linha de produtos alimentícios',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/c3b7c84d9e8acb6be397a6ef2da0e43f.jpeg',
      downloadUrl: '/enjoy'
    },
    {
      id: 3,
      title: 'Nutrare',
      description: 'Conheça toda nossa linha de produtos alimentícios',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fdd564c3ce97b799ca231938ffc5fcc.jpeg',
      downloadUrl: '/nutrare'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Marcas Sustentare
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nossas marcas desenvolvidas especialmente para cada tipo de mercado.
          </p>
        </div>

        {/* Catalogs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {catalogs.map((catalog) => (
            <div key={catalog.id} className="bg-white rounded-2xl shadow-xl overflow-hidden group hover:transform hover:scale-105 transition-all duration-300">
              <div className="aspect-[4/5] overflow-hidden">
                <img 
                  src={catalog.image}
                  alt={catalog.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {catalog.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {catalog.description}
                </p>
                {catalog.downloadUrl.startsWith('http') ? (
                  <a 
                    href={catalog.downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-full px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-eye-line mr-2"></i>
                    Conhecer Marca
                  </a>
                ) : (
                  <Link 
                    to={catalog.downloadUrl}
                    className="inline-flex items-center justify-center w-full px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-eye-line mr-2"></i>
                    Conhecer Marca
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA removed */}
      </div>
    </section>
  );
};

export default CatalogSection;
